import { breakpoints } from '../config/breakpoints';

export default function () {
  sessionStorage.removeItem('preloaderDone');

  document.body.style.overflow = 'hidden';

  let preloaderTimeOut = false;

  setTimeout(() => {
    preloaderTimeOut = true;
  }, 7000);

  const pageWidth = document.documentElement.clientWidth;
  const currentPageWidth = pageWidth > breakpoints.xxl ? breakpoints.xxl : pageWidth;
  let preloaderWidthPercent = 0.32;
  // eslint-disable-next-line no-use-before-define
  calculatePreloaderWidthPercent();
  const preloaderProgressWidth = currentPageWidth * preloaderWidthPercent;

  const preloaderDoneEvent = new Event('preloaderDone');

  const preloaderEl = document.querySelector('[data-preloader]');
  const preloaderContainer = document.querySelector('[data-preloader-container]');
  const preloaderTextContainer = document.querySelector('[data-preloader-text]');
  const preloaderFirstLetter = document.querySelector('[data-preloader-letter-first]');
  const preloaderSecondLetter = document.querySelector('[data-preloader-letter-second]');
  const preloaderThirdLetter = document.querySelector('[data-preloader-letter-third]');
  const preloaderFourthLetter = document.querySelector('[data-preloader-letter-fourth]');
  const preloaderProgress = document.querySelector('[data-preloader-progress]');
  const preloaderOverlay = document.querySelector('[data-preloader-overlay]');

  // animated by css
  preloaderOverlay.style.transform = 'translateY(-100%)';

  let preloaderCurrentLetter = 'a';
  let interval;

  // eslint-disable-next-line no-use-before-define
  basicStilization();
  // eslint-disable-next-line no-use-before-define
  startAnimation();

  function calculatePreloaderWidthPercent() {
    preloaderWidthPercent = window.innerWidth > breakpoints.xxl ? 0.22 : 0.32;
  }

  function basicStilization() {
    preloaderFirstLetter.style.marginLeft = `${-preloaderProgressWidth / 1.5}px`;
    preloaderSecondLetter.style.marginLeft = `${-preloaderProgressWidth / 2}px`;
    preloaderFourthLetter.style.marginLeft = `${preloaderFourthLetter.offsetWidth * 4}px`;
    preloaderProgress.style.marginLeft = `${-(preloaderProgressWidth / 1.5 - preloaderFirstLetter.offsetWidth / 2)}px`;
  }

  function startAnimation() {
    // pause before overlay effect (css)
    setTimeout(() => {
      preloaderFirstLetter.style.marginTop = 0;
      preloaderFirstLetter.style.opacity = 1;
      preloaderFirstLetter.transitionDuration = '0.5s';

      // pause before letter a animation
      setTimeout(() => {
        preloaderFirstLetter.style.color = '#f8f8f8';
        preloaderFirstLetter.style.paddingLeft = '10px';

        // pause before letter z
        setTimeout(() => {
          preloaderFirstLetter.style.color = '#eda593';
          preloaderSecondLetter.style.marginLeft = 0;
          preloaderSecondLetter.style.opacity = 1;
          // eslint-disable-next-line no-use-before-define
          interval = setInterval(letterTween, 80);
          preloaderProgress.style.transitionDuration = '2s';
          preloaderProgress.style.width = '1px';
        }, 500);
      }, 500);
    }, 500);
  }

  function endAnimation() {
    preloaderSecondLetter.style.transitionDuration = '0.2s';
    preloaderSecondLetter.style.color = '#eda593';
    preloaderSecondLetter.style.marginLeft = `${preloaderProgressWidth / 3 + preloaderSecondLetter.offsetWidth}px`;

    // pause before collapse
    setTimeout(() => {
      preloaderProgress.style.transitionDuration = '1.5s';
      preloaderProgress.style.width = 0;
      preloaderFirstLetter.style.transitionDuration = '1.5s';
      preloaderSecondLetter.style.transitionDuration = '1.5s';
      preloaderFirstLetter.style.marginLeft = `${-preloaderSecondLetter.offsetWidth * 2.15}px`;
      preloaderProgress.style.marginLeft = `${-preloaderSecondLetter.offsetWidth * 2.15}px`;
      preloaderSecondLetter.style.marginLeft = `${-preloaderSecondLetter.offsetWidth / 1.25}px`;
      preloaderThirdLetter.style.marginLeft = `${preloaderSecondLetter.offsetWidth / 1.9}px`;

      preloaderFirstLetter.style.color = '#f8f8f8';
      preloaderSecondLetter.style.color = '#f8f8f8';

      // pause before letter d
      setTimeout(() => {
        preloaderThirdLetter.style.opacity = 1;

        // pause before letter s
        setTimeout(() => {
          preloaderFourthLetter.style.opacity = 1;
          preloaderFourthLetter.style.marginLeft = `${preloaderSecondLetter.offsetWidth * 1.9}px`;
        }, 500);
      }, 1500);
    }, 500);
  }

  function restartAnimation() {
    preloaderCurrentLetter = 'a';
    preloaderSecondLetter.style.transitionDuration = '0s';
    preloaderSecondLetter.style.marginLeft = 0;
    preloaderSecondLetter.style.color = '#f8f8f8';
    preloaderSecondLetter.style.opacity = 0;
    preloaderThirdLetter.style.opacity = 0;
    preloaderFourthLetter.style.opacity = 0;
    preloaderProgress.style.transitionDuration = 0;
    basicStilization();
    startAnimation();
  }

  function letterTween() {
    preloaderCurrentLetter = String.fromCharCode(preloaderCurrentLetter.charCodeAt(0) + 1);
    preloaderSecondLetter.textContent = preloaderCurrentLetter;
    preloaderProgress.style.width = `${preloaderProgressWidth}px`;
    if (preloaderCurrentLetter === 'z') {
      clearInterval(interval);
      endAnimation();
      // eslint-disable-next-line no-use-before-define
      setTimeout(checkPageLoad, 1500);
    }
  }

  function overlayOut() {
    preloaderOverlay.style.transitionDuration = '0s';
    preloaderOverlay.style.transform = 'translateY(100%)';
    setTimeout(() => {
      preloaderOverlay.style.transitionDuration = '0.5s';
      preloaderOverlay.style.backgroundColor = 'black';
      preloaderOverlay.style.transform = 'translateY(0)';
      preloaderContainer.style.transform = 'translateY(-100%)';
      preloaderTextContainer.style.opacity = 0;
    }, 500);
    setTimeout(() => {
      preloaderOverlay.style.backgroundColor = '#e1512d';
      preloaderOverlay.style.transform = 'translateY(-100%)';
    }, 1000);
  }

  function preloaderClose() {
    setTimeout(() => {
      overlayOut();
      document.body.style.overflowY = 'auto';
    }, 2000);
    setTimeout(() => {
      document.dispatchEvent(preloaderDoneEvent);
      preloaderEl.remove();
    }, 3500);
  }

  function checkPageLoad() {
    if (document.readyState === 'complete' || preloaderTimeOut === true) {
      preloaderClose();
    } else {
      setTimeout(() => {
        restartAnimation();
      }, 2000);
      window.addEventListener('load', preloaderClose);
    }
  }

  window.addEventListener('resize', () => {
    calculatePreloaderWidthPercent();
  });
}
